<template>
  <form class="form-horizontal">
    <card >
      <div slot="header" class="card-header">
        <h4 class="card-title">{{model.location}}</h4>
      </div>
      <div class="table-responsive table-full-width">
        <el-table :data="shelvesByMachine" border :show-header="false" v-loading="loading">
          <el-table-column label="Molas">
            <div slot-scope="props">
              <h5
                v-if="props.row.position || props.row.position === 0"
              >{{ `Módulo ${String.fromCharCode(props.row.position + 65)}` }}</h5>
              <el-table :data="coilsByShelf[props.$index]" width="100%" border >
                <el-table-column label="#" width="70">
                  <template slot-scope="props">{{ props.row.position + 1 }}</template>
                </el-table-column>
                <el-table-column label="Produto" min-width="250">
                  <template slot-scope="props">
                    <fg-input>
                      <el-select
                        class="select-default"
                        size="large"
                        filterable
                        @blur="clearVar(props.row)"
                        placeholder="Digite para filtrar"
                        v-model="props.row.product"
                      >
                        <el-option
                          v-for="option in products"
                          class="select-danger"
                          :value="option.id"
                          :label="`${option.name}`"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </template>
                </el-table-column>
                <el-table-column label="Variação" min-width="200">
                  <template slot-scope="props">
                    <fg-input>
                      <el-select
                        class="select-default"
                        size="large"
                        filterable
                        placeholder="Digite para filtrar"
                        v-model="props.row.product_variant"
                      >
                        <el-option
                          v-for="option in productVariants(props.row.product)"
                          class="select-danger"
                          :value="option.id"
                          :label="`${option.name}`"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </template>
                </el-table-column>

                <el-table-column label="Status" width="160">
                  <template slot-scope="props">
                    <fg-input>
                      <el-select
                        class="select-default"
                        size="large"
                        filterable
                        placeholder="Selecione"
                        v-model="props.row.control"
                      >
                        <el-option
                          v-for="option in statusOpt"
                          class="select-danger"
                          :value="option.value"
                          :label="option.label"
                          :key="option.value"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </template>
                </el-table-column>

                <el-table-column label="Quantidade" width="160">
                  <template slot-scope="props">
                    <fg-input>
                      <el-select
                        class="select-default"
                        size="large"
                        placeholder="Selecione"
                        v-model="props.row.amount"
                      >
                        <el-option
                          v-for="option in qtd"
                          class="select-danger"
                          :value="option.id"
                          :label="`${option.name}`"
                          :key="option.id"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </template>
                </el-table-column>
                <el-table-column label="Tamanho" width="120">
                  <template slot-scope="props">
                    <fg-input>
                      <el-select
                        class="select-default"
                        size="large"
                        placeholder="Selecione"
                        v-model="props.row.size"
                      >
                        <el-option
                          v-for="option in boxSize"
                          class="select-danger"
                          :value="option.value"
                          :label="option.name"
                          :key="option.name"
                        ></el-option>
                      </el-select>
                    </fg-input>
                  </template>
                </el-table-column>
                <el-table-column label="Validade" width="170">
                  <template slot-scope="props">
                    <fg-input>
                      <el-date-picker
                        v-model="props.row.expiration_date"
                        type="date"
                        format="dd/MM/yyyy"
                        placeholder="Selecione"
                      ></el-date-picker>
                    </fg-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer">
        <el-button type="primary" :loading="btnLoading" 
          @click.prevent="saveCoils">Salvar</el-button>
      </div>
    </card>
    <!-- <card>
      <div>
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info btn-wd">Salvar</button>
      </div>
    </card>-->
  </form>
</template>
<script>
import {
  Select,
  Button,
  Option,
  DatePicker,
  TimeSelect,
  Slider,
  Loading,
  Table,
  TableColumn
} from "element-ui";

import { Switch as LSwitch } from "src/components/index";
import swal from "sweetalert2";

export default {
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [Slider.name]: Slider,
    [Table.name]: Table,
    [Button.name]: Button,
    [TableColumn.name]: TableColumn,
    LSwitch
  },
  created() {
    var ciaID = localStorage.getItem('smartmachCiaID')
    if (ciaID) { 
      ciaID = ciaID
    } else {
      ciaID = ''
    }
    this.$store.dispatch("products/listSort",{sort: '?company=' + ciaID + '&archived=False'}).then(() => {
      this.$store.dispatch("products/variants/listSort",{sort: '?company=' + ciaID + '&archived=False'}).then(() => {
        this.$store.dispatch("modulos/listSort",{sort: '?company=' + ciaID}).then(() => {
          this.$store.dispatch("boxes/listSort", {sort: '?shelf__vm=' + 
          this.$route.params.id + '&ordering=id' + '&page_size=161'}).then(() => {
            if (this.$route.params.id) {
              this.$store.dispatch("lockers/get", {id: this.$route.params.id}).then(resp => {
                console.log('resp', resp)
                this.model = resp
              });
              this.crud = "Editar";
            } else {
              this.crud = "Criar";
            }
          });
        });
      });
    });
    // setInterval(function() {
    //   window.location.reload()
    // }, this.$store.state.general.timer)
  },
  computed: {
    users() {
      return this.$store.state.users.users;
    },
    products() {
      const p = this.$store.state.products.products;
      const withVariants = p.map(v => {
        const variants = this.variants.filter(e => e.product == v.id);
        return { ...v, variants };
      });
      return withVariants;
    },
    variants() {
      return this.$store.state.products.variants.variants;
    },
    shelves() {
      return this.$store.state.modulos.modulos;
    },
    coils() {
      return this.$store.state.boxes.boxes;
    },
    productVariants() {
      return product => {
        const p = this.products.find(e => e.id == product) || {};
        const v = p.variants;
        return v;
      };
    },
    shelvesByMachine() {
      const shelves = [...this.$store.state.modulos.modulos];
      const byMachine = shelves.filter(e => e.vm === this.model.id);
      console.log({ byMachine })
      setTimeout(() => {
        this.loading = false        
      }, 30000);
      console.log({byMachine})
      return byMachine;
    },
    coilsByShelf() {
      const coils = [...this.$store.state.boxes.boxes];
      const shelves = [...this.shelvesByMachine];
      const dateConverted = coils.map(v => {
        let expiration_date = v.expiration_date
        let letter, vm_position
        if (v.expiration_date) {
          const d = v.expiration_date.split("-").join("/");
          expiration_date = d;
        }
        if(v.vm_position){
          letter = v.vm_position.charAt(0)
          vm_position = v.vm_position.substr(1)
        }
        return { ...v, expiration_date, letter, vm_position };
      });
      const byShelf = shelves.map(v => {
        const c = dateConverted.filter(e => e.shelf === v.id && e.active === true);
        return [...c];
      });
      this.loading = false
      for (let index = 0; index < byShelf.length; index++) {
        byShelf[index] = byShelf[index].sort((a,b) => (Number(a.vm_position) > Number(b.vm_position)) ? 1 : ((Number(b.vm_position) > Number(a.vm_position)) ? -1 : 0))
      }
      console.log({byShelf})
      return byShelf
    }
  },
  data() {
    return {
      crud: "Editar",
      loading: true,
      btnLoading: false,
      fullscreenLoading: true,
      message: "Sucesso</br>Item Salvo!",
      alertColor : '',
      qtd: [{id: 0, name: 'vazio'},{id: 1, name: 'cheio'}],
      statusOpt: [{value: "Novo", label: 'Novo'},
                {value: "Danificado", label: 'Danificado'}],
      boxSize: [{value: "PP", name: 'PP'},
                {value: "P", name: 'P'},
                {value: "M", name: 'M'},
                {value: "G", name: 'G'},
                {value: "GG", name: 'GG'}],
      model: {
        user: "",
        location: "",
        vpn_key: "",
        mac: "",
        ip: "",
        last_communication: "",
        coil_per_shelf: "",
        sound: false,
        volume: 30,
        maintence_pwd: "",
        repositor_pwd: "",
        payment: false,
        video: false,
        serial_term: "",
        itens_per_sale: "",
        id_externo: "",
        control: 'Novo'
      },
      modelValidations: {
        name: {
          required: true
        },
        price: {
          required: true,
          regex: /^[0-9]+((,|.)[0-9]{2}){1}$/
        }
      }
    };
  },
  methods: {
    handleDeleteShelf(i, row) {
      console.log(row);
      const itemName = "Modulo";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("shelves/delete", { id: row.id });
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    handleSaveCoil(i, row) {
      const r = { ...row };
      if (r.expiration_date) {
        const d = new Date(r.expiration_date).toISOString();
        r.expiration_date = d.split("T")[0];
      }
      console.log("saving", r);
      this.$store
        .dispatch("boxes/update", { item: r })
        .then(() => {
          this.notifySuccess();
        })
        .catch(err => console.log(err));
    },
    saveCoils() {
      this.btnLoading = true
      const coils = this.coilsByShelf.flat();
      const dateConverted = coils.map(v => {
        let expiration_date = v.expiration_date;
        let vm = this.model.id;
        let vm_position
        // let company = Number(this.$store.state.auth.company)
        if (v.expiration_date) {
          const d = new Date(v.expiration_date).toISOString();
          expiration_date = d.split("T")[0];
        }
        if (v.vm_position) {
          vm_position = v.letter + v.vm_position
        }

        return { ...v, expiration_date, vm_position};
      });
      let payload = { data: dateConverted, item: this.model.id };
      console.log('payload', payload)
      this.$store.dispatch("machines/update_coils", payload).then(result => {
        if (result.length === undefined) {
          this.btnLoading = false
          this.$notify({
            message: "Erro</br>VM não atualizada!",
            icon: "nc-icon nc-app",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: "danger"
          })
        } else {
          var color
          this.btnLoading = false
          this.message = "Sucesso</br>Item Salvo!" 
          color = 'success'
          for (let index = 0; index < payload.data.length; index++) {
            if (payload.data[index].product === null){
                this.message = 'Sucesso</br>Item Salvo! Mas há molas vazias.'  
                color = 'warning'      
              }
            }
          this.$notify({
            message: this.message,
            icon: "nc-icon nc-app",
            horizontalAlign: "right",
            verticalAlign: "bottom",
            type: color
          });
          this.$router.push(`/app/machines/lockers`);
        }
      })
    },
    handleDeleteCoil(i, row) {
      console.log(row);
      const itemName = "Box";
      swal.fire({
        title: "Tem certeza?",
        text: `Você está prestes a excluir esse(a) ${itemName}.`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn btn-success btn-fill",
        cancelButtonClass: "btn btn-danger btn-fill",
        confirmButtonText: "Sim, exclua!",
        cancelButtonText: "Cancelar",
        buttonsStyling: false
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("coils/delete", { id: row.id });
          swal.fire({
            title: "Pronto!",
            text: `${itemName} excluído(a).`,
            icon: "success",
            confirmButtonClass: "btn btn-success btn-fill",
            buttonsStyling: false
          });
        } else if (result.dismiss === "cancel") {
          swal.fire({
            title: "Ops!",
            text: `${itemName} não excluído(a).`,
            icon: "error",
            confirmButtonClass: "btn btn-info btn-fill",
            buttonsStyling: false
          });
        }
      });
    },
    notifySuccess() {
      this.$notify({
        message: this.message,
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "success"
      });
    },
    notifyError() {
      this.$notify({
        message: "Erro</br>Item não Salvo!",
        icon: "nc-icon nc-app",
        horizontalAlign: "right",
        verticalAlign: "bottom",
        type: "danger"
      });
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    color(value) {
      if (value <= 75) {
        return "slider-success";
      } else {
        return "slider-danger";
      }
    },
    QuantvsCap (item) {
      if (Number(item.amount) > Number(item.capacity)) {
        alert('Quantidade não pode ser maior que Capacidade')
        item.amount = item.capacity
      }
    },
    clearVar (data) {
      data.product_variant = ''
    },
  }
};
</script>
<style scoped>
img {
  width: 200px;
}
.img-upload {
  border: 1px solid #ccc;
  border-radius: 5px;
  display: inline-block;
  padding: 10px;
  margin-bottom: 20px;
}
.card-header {
  display: flex;
}
.card-header button {
  margin-left: auto;
}
.card-footer {
  display: flex;
  text-align: right;
}
.card-footer > div {
  display: flex;
  text-align: right;
}
.card-footer button {
  margin-left: auto;
}
.table-responsive .form-group {
  margin: 0;
}
</style>
